<template>
	<div>
		{{ question.Value.Description }}
		<i v-if="question.Value.Required">*</i>
		<info-text :info-text="question.Value.ToolTipText"></info-text>
		<br />
		<div :key="opt" v-for="(opt, value) in question.Value.Options">
			<input
				type="radio"
				:name="question.Key"
				:id="question.Key + opt"
				class="c-inputfields__input--radio"
				@change="emitChange"
				v-model="question.Value.UserValue"
				:value="opt"
			/>
			<label :for="question.Key + opt" class="value-label c-inputfields__label">{{ value }}</label>
		</div>
	</div>
</template>

<script>
import InfoText from '@/partials/InfoText';
export default {
	components: { InfoText },
	props: ['question'],
	methods: {
		emitChange: function() {
			this.$emit('updatedvalue', {
				question: this.question,
				update: this.question.Value.RequiresRefresh
			});
		}
	}
};
</script>

<style></style>
